import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import {
	EmailReplyMeta,
	GmailReplyData,
	IModalAction,
	IProductPackageItem
} from '@models/models';
import { SNModalService } from '@web-services/modal/snModal.service';
import { EmailReplyConfirmModalComponent } from '@web-components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Subscription } from 'rxjs/Subscription';
import { EmailSettingsDataService } from '@services/settings/email-settings.data.service';
import { EmailAlertModalComponent } from '@web-components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component';
import { EmailSettingsService } from '@services/settings/email-settings.service';

@Component({
	selector: 'email-reply-modal',
	template: require('./email-reply-modal.component.html'),
	styles: [require('./email-reply-modal.component.scss')]
})
export class EmailReplyModalComponent {
	@Input() emailData: GmailReplyData;
	@Input() disableBtn: boolean;
	@Output() onSaveSettings = new EventEmitter();
	@Output() onModalClose: EventEmitter<void> = new EventEmitter();

	confirmModalRef: NgbModalRef;

	constructor(
		private messageService: MessageService,
		private modalService: SNModalService
	) {}

	saveEmailReplyForm(): void {
		if (
			this.emailData.replyConfirmationHtml &&
			this.emailData.replySettingsMetadata.enabled
		) {
			this.openConfirmModal();
		} else {
			this.closeWithData();
		}
	}

	dismiss(): void {
		this.onModalClose.emit();
	}

	closeWithData(): void {
		this.onSaveSettings.emit({ data: this.emailData });
	}

	onEmailConfirm(data: EmailReplyMeta): void {
		this.emailData.replySettingsMetadata = JSON.parse(JSON.stringify(data));
		this.emailData.replySettingsMetadata.enabled = true;
	}

	private openConfirmModal(): void {
		this.confirmModalRef = this.modalService.openModal(
			EmailAlertModalComponent,
			{
				windowClass: 'ng-bootstrap-modal__small'
			}
		);
		document.body.classList.remove('modal-open');

		this.confirmModalRef.componentInstance.btnDisabled = false;
		this.confirmModalRef.componentInstance.messageToShow = this.emailData.replyConfirmationHtml;

		this.confirmModalRef.result.then((): void => {
			document.body.classList.add('modal-open');
			this.closeWithData();
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/email-settings-section/modals/email-reply-modal/email-reply-modal.component.ts